import './Loading.css';

const Loading = ({ message }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
        <div className="loading-text">{message}</div>
    </div>
  );
};

export default Loading;